// @ts-strict-ignore
import { FC } from 'react'

import { HeroInfoBlock } from '@/widgets/HeroInfoBlock'
import { SquareCatBlock } from '@/widgets/SquareCatBlock'
import { StepsSimple } from '@/widgets/StepsSimple/StepsSimple'

import { CatalogItem } from '@/entities/catalog/types'

import { AdvLine } from '@/shared/ui/AdvLine/AdvLine'
import { FaqSection } from '@/shared/ui/FaqSection'
import Flex from '@/shared/ui/Flex'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { PdfList } from '@/shared/ui/PdfList'

import { AdvLineData, faqItemsFiz, heroInfoDataFiz, pdfListFiz, stepsList } from './data'
import { SectionTradeIn } from './ui/section-trade-in/section-trade-in'

import styles from './styles.module.scss'

type TradeInProps = {
	catalogItems: CatalogItem[]
}

export const TradeIn: FC<TradeInProps> = ({ catalogItems }) => (
	<div className={styles.tradeIn}>
		<HeroInfoBlock
			tabItems={[
				{
					title: `Физическое лицо`,
					link: `/services/trade-in/`,
					isActive: true
				},
				{ title: `Юридическое лицо`, link: `/b2b/trade-in/`, isActive: false }
			]}
			{...heroInfoDataFiz}
			customButton={null}
		/>

		<HorizontalSection title="Как это работает?">
			<Flex className={styles.horizontalSectionContent}>
				{stepsList.map((item, index) => (
					<StepsSimple {...item} key={index} />
				))}
			</Flex>
		</HorizontalSection>

		<SectionTradeIn />

		<SquareCatBlock items={catalogItems} title="Каталог" />

		<HorizontalSection title="Частые вопросы">
			<FaqSection items={faqItemsFiz} />
		</HorizontalSection>

		<PdfList items={pdfListFiz} />

		<AdvLine {...AdvLineData} />
	</div>
)
